<!-- eslint-disable max-lines -->
<template>
    <div class="bidding-account-manage">
        <Paper class="bidding-account-manage-paper">
            <el-tabs class="bidding-list-tab-pane" v-model="activeTabs" @tab-remove="removeTab" @tab-click="switchTabs">
                <el-tab-pane label="投标账号列表" name="theList" ref="myPane" v-loading="holePageLoading">
                    <list-layout-paper>
                        <template slot="header-search" class="searchBox">
                            <search-box ref="searchBox" :search-key="config.name" :fields="config.searchFields"
                                :showResetBtn="true" @search-change="accountList.searchList" />
                        </template>
                        <template slot="header-button" class="bidding-account-manage-btn">
                            <lotsButton v-has="authorityCode.add" type="primary" icon="el-icon-circle-plus-outline"
                                size="mini" title="新增">
                                <el-dropdown class="bidding-account-manage-list-dropdown" trigger="hover"
                                    :append-to-body="false">
                                    <span class="el-dropdown-link">
                                        新增<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="bidding-account-manage-list-dropdown-menu">
                                        <el-dropdown-item class="dropdown-item"
                                            @click.native="handleAddRow('1')">公网投标网站</el-dropdown-item>
                                        <el-dropdown-item class="dropdown-item"
                                            @click.native="handleAddRow('2')">私网投标网站</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </lotsButton>
                            <lotsButton v-has="authorityCode.save" icon="el-icon-circle-check" type="primary" size="mini" title="保存"
                                @click="handleBatchSave">保存
                            </lotsButton>
                            <lotsButton v-has="authorityCode.import" icon="el-icon-upload2" type="primary" size="mini" title="导入"
                                @click="openImport">导入
                            </lotsButton>
                            <lotsButton v-has="authorityCode.export" icon="el-icon-download" type="primary" size="mini"
                                title="导出" @click="handleExport">导出
                            </lotsButton>

                            <el-tooltip effect="dark" content="列配置" placement="bottom">
                                <el-button icon="iconfont icon-list_install" type="primary" size="mini"
                                    @click="showColumnConfigDialog" plain />
                            </el-tooltip>
                        </template>
                        <template v-slot:list="{ tableHeight }">
                            <edit-table-box ref="editTableBoxRef" :height="tableHeight"
                                v-loading="accountList.tableLoading" :selection="config.selection" :index="config.index"
                                :columns="config.columns" :tableData="accountList.totalData" :control="true"
                                :actions="config.actions" @btn-event="handleBtnEvent" :allowRowClick="false"
                                @selection-change="accountList.handleSelectedRow" @sort-change="handleSort"
                                @element-change="handleElementChange" @row-db-click="rowDBclick">
                                <template #col-header="{ item }">
                                    <span class="header-label-text">{{ item.label }}</span>
                                    <col-header-filter v-if="item.filterType" :item="item"
                                        :popoverWidth="item.popoverWidth" @filter="handleColFilter" :showLabel="false" />
                                    <img v-if="['accountPassword', 'websiteAccount', 'registrantPhone'].includes(item.prop)"
                                        class="text-eyes"
                                        :src="getFieldVisible(item.prop) ? iconOpenEyes : iconCloseEyes" alt=""
                                        @click.stop="toggleGlobalPassword(item.prop)" />
                                </template>
                                <template #col-append="{ item, row, rIndex }">
                                    <span
                                        v-if="['customerLevel', 'accountType', 'hasUpdateIn90days','accountStatus'].includes(item.prop)">{{
                                            codesToNames(row[item.prop] + '',
                                        dictDatas[item.optionsKey]) }}</span>
                                    <a v-else-if="item.prop === 'websiteUrl' && row.edit === -3" :href="getWebsiteUrl(row[item.prop])"
                                        target="_blank" class="website-url-link">{{ row[item.prop] }}</a>
                                    <span v-else-if="item.prop === 'accountRegistrantName'">{{ row[item.prop] }}</span>
                                    <span v-else-if="item.prop === 'accountManagerName'">{{ row[item.prop] }}</span>
                                    <span v-else-if="item.prop === 'customerManagerName'">{{ row[item.prop] }}</span>
                                    <span v-else-if="item.prop === 'websiteAccount' && row.edit === -3 && row[item.prop]" class="password-cell">
                                        <span class="password-text" :title="getRowPasswordShow(row, 'websiteAccount') ? row[item.prop] : ''">
                                            {{ getRowPasswordShow(row, 'websiteAccount') ? row[item.prop] : maskAccount(row[item.prop]) }}
                                        </span>
                                        <img class="row-eyes" :src="getRowPasswordShow(row, 'websiteAccount') ? iconOpenEyes : iconCloseEyes" alt=""
                                        @click.stop="toggleRowPassword(row, 'websiteAccount')" />
                                    </span>
                                    <span v-else-if="item.prop === 'accountPassword' && row.edit === -3 && row[item.prop]" class="password-cell">
                                        <span class="password-text" :title="getRowPasswordShow(row, 'accountPassword') ? row[item.prop] : ''">
                                            {{ getRowPasswordShow(row, 'accountPassword') ? row[item.prop] : '********' }}
                                        </span>
                                        <img class="row-eyes" :src="getRowPasswordShow(row, 'accountPassword') ? iconOpenEyes : iconCloseEyes" alt=""
                                        @click.stop="toggleRowPassword(row, 'accountPassword')" />
                                    </span>
                                    <span v-else-if="item.prop === 'registrantPhone' && row.edit === -3 && row[item.prop]" class="password-cell">
                                        <span class="password-text" :title="getRowPasswordShow(row, 'registrantPhone') ? row[item.prop] : ''">
                                            {{ getRowPasswordShow(row, 'registrantPhone') ? row[item.prop] : desensitization.phone(row[item.prop]) }}
                                        </span>
                                        <img class="row-eyes" :src="getRowPasswordShow(row, 'registrantPhone') ? iconOpenEyes : iconCloseEyes" alt=""
                                        @click.stop="toggleRowPassword(row, 'registrantPhone')" />
                                    </span>
                                    <span size="mini" v-else-if="item.prop === 'customerWhitelistCode'" type="text"
                                        class="customer-mip-page-link no-wrap" @click="handleLink(row)">{{
                                        row.customerWhitelistCode}}</span>
                                    <span size="mini" v-else-if="item.prop === 'idNumber'" type="text"
                                        class="mip-page-link no-wrap" :title="row[item.prop]">{{
                                            encryptionHandle(row[item.prop] || '', item.prop) }}
                                    </span>
                                </template>
                                <template v-slot:edit-col-append="{ item, row, rIndex }">
                                    <span
                                        v-if="['customerLevel', 'accountType', 'hasUpdateIn90days','accountStatus'].includes(item.prop)">{{
                                            codesToNames(row[item.prop] + '',
                                        dictDatas[item.optionsKey]) }}</span>

                                    <el-input v-else-if="item.prop === 'websiteUrl'" v-model="row[item.prop]"
                                        :maxlength="200" placeholder="请输入投标网址，支持www或https://开头" size="mini" />
                                    <el-input v-else-if="item.prop === 'remark'" v-model="row[item.prop]"
                                        type="textarea" :rows="3" :maxlength="500" show-word-limit placeholder="请输入备注" size="mini" />
                                </template>
                            </edit-table-box>
                        </template>
                        <template slot="footer">
                            <lots-pagination @size-change="accountList.sizeChange"
                                :current-page.sync="accountList.pageNo" @current-change="accountList.pageChange"
                                layout="total, sizes, prev, pager, next, jumper" :total="accountList.pageTotal">
                            </lots-pagination>
                        </template>
                    </list-layout-paper>
                </el-tab-pane>
                <el-tab-pane closable :class="item.code + item.detailPageState" v-for="item in tabList"
                    :key="item.code + item.detailPageState" :label="item.contractMark" class="bidding-name-tab"
                    :name="item.code + item.detailPageState">
                    <detail-page :ref="`datailTabs${item.code + item.detailPageState}`" :code="item.code"
                        :key="item.detailPageState" :activeTabs="activeTabs" :detailPageState="item.detailPageState"
                        :detailData="item.detailData">
                    </detail-page>
                </el-tab-pane>
            </el-tabs>
            <column-config :pageID="config.name" :initColumns="config.columns" ref="otpColumnConfig"
                @header-change="config.columns = $event" />
        </Paper>
        <addFileDialog ref="fileDialogRef" :config="config.importConfig" @uploadSuccessHandle="uploadSuccessHandle"
            @uploadFailHandle="uploadFailHandle">
        </addFileDialog>
    </div>
</template>
<script>
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import editTableBox from '@/components/lots/editTableBox/Index';
import colHeaderFilter from '@/modules/mdm/components/colHeaderFilter/Index';
import {
    getBiddingAccountList, biddingAccountEnableApi, biddingAccountDiscardApi,
    biddingAccountExportApi, biddingAccountBatchSaveApi, getBiddingAccountPermissionApi, getBiddingAccountDetailApi
} from '@/modules/mdm/api/customer/biddingAccountManage.js';
import { ListClass } from '@/modules/mdm/composition/dc/common/list/ListClass';
import { config as configStatic } from './config';
import { ref, reactive, onMounted, getCurrentInstance, computed, watch } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import lotsButton from '@/components/lots/lotsButton';
import store from '@/store/index';
import addFileDialog from '@/modules/mdm/components/addFileDialog/Index.vue';
import detailPage from './detail/Detail.vue';
import columnConfig from '@/components/lots/columnConfig/Index';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import { filterEventBus } from './filterEventBus';
import iconOpenEyes from '@/assets/images/icon-open-eyes.png';
import iconCloseEyes from '@/assets/images/icon-close-eyes.png';
import _ from 'lodash';
const defaultNotNecessaryProps = [
    'accountRegistrant', 'remark', 'customerOwnerName',
    'accountRegistrantName', 'accountManagerStatus', 'hasUpdateIn90days',
    'customerManager', 'customerManagerName', 'accountManagerName',
    'isReviewed', 'createTime', 'updateTime', 'passwordUpdateTime',
    'accountManagerUpdateTime', 'customerGroupName', 'accountStatus', 'customerLevel',
    'managerUpdateTime'
];
export default {
    name: 'biddingAccountManage',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        editTableBox,
        colHeaderFilter,
        lotsPagination,
        lotsButton,
        addFileDialog,
        detailPage,
        columnConfig
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive(_.cloneDeep(configStatic));
        const authorityCode = reactive(btnAuthority.biddingAccountManage);
        // const configCol = computed(() => {
        //     config.forEach(it => {
        //         if (it.prop === 'accountManager') {
        //             it.disabled = true;
        //         }
        //     });
        // });
        class AccountListClass extends ListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList(res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        v.edit = -3;
                        v.allowEdit = otherUtils.getHasAuth(btnAuthority.biddingAccountManage.edit);
                        v.enableLoading = false;
                        v.accountType = v.accountType?.toString();
                        v.isReviewed = v.isReviewed?.toString();
                        v.hasUpdateIn90days = v.hasUpdateIn90days?.toString();
                        v.accountPasswordVisible = false;
                        v.registrantPhoneVisible = false;
                        v.websiteAccountVisible = false;
                        v.backup = _.cloneDeep(v);
                        delete v.backup.backup;
                        const disableProps = [];
                        if (v.accountType?.toString() === '1') {
                            disableProps.push('customerName');
                        }
                        if (accountRegistrantDisabled.value) {
                            disableProps.push('accountRegistrant');
                        }
                        if (accountManagerDisabled.value) {
                            disableProps.push('accountManager');
                        }
                        if (disableProps.length > 0) {
                            v.disableProps = disableProps;
                        }
                        if (v.accountType?.toString() === '1') {
                            v.notNecessaryProps = [...defaultNotNecessaryProps, 'customerName'];
                        } else {
                            v.notNecessaryProps = defaultNotNecessaryProps;
                        }
                        return v;
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
                globalVisibleMap.accountPassword.value = false;
                globalVisibleMap.websiteAccount.value = false;
                globalVisibleMap.registrantPhone.value = false;
                updateColumnDisabled();
            }
        }

        const accountList = new AccountListClass({
            Api: {
                listApi: getBiddingAccountList
            }
        });

        const ctx = getCurrentInstance();
        const tabList = ref([]);
        const activeTabs = ref('theList');
        const holePageLoading = ref(false);
        const currDetailData = ref({});
        const { userCode, userName } = store.getters.user;
        const otpColumnConfig = ref(null);
        const showColumnConfigDialog = () => {
            otpColumnConfig.value.show(true);
        };

        const jumpToDetail = (query = {}) => {
            ctx.$router.replace({ path: '/mod/mdm/bidding-account-manage', query });
        };

        const removeTab = (targetName) => {
            if (activeTabs.value === targetName) {
                activeTabs.value = 'theList';
                jumpToDetail();
            }
            tabList.value = tabList.value.filter(
                (tab) => (tab.code + tab.detailPageState) !== targetName
            );
        };

        const switchTabs = (data) => {
            if (data.name !== 'theList') {
                const currentTab = tabList.value[Number(data.index) - 1];
                if (currentTab?.code === ctx.$route.query.id) return;
                jumpToDetail({ id: currentTab?.code });
            } else {
                jumpToDetail();
            }
        };

        const rowDBclick = (row) => {
            // eslint-disable-next-line no-magic-numbers
            if (row.edit !== -3) return;
            currDetailData.value = _.cloneDeep(row);
            const { id } = row;
            const code = id;
            const name = row.websiteName || '投标网站';
            newDetailPage(code, currDetailData.value, name, 'main');
        };

        const newDetailPage = (code, data, name, state) => {
            const judge = tabList.value.filter((item) => (item.code + item.detailPageState) === code + state);
            const insertBeforeJudge = tabList.value.filter((item) => (item.code === code && item.detailPageState !== state));
            if (judge.length === 0 && tabList.value.length === 8) {
                Message.warning('已超出8个详情页，请关闭后重新打开');
            } else {
                const dataGather = {
                    contractMark: name,
                    code,
                    detailData: _.cloneDeep(data),
                    detailPageState: state
                };
                if (judge.length === 0 && insertBeforeJudge.length === 0) {
                    tabList.value.push(dataGather);
                }
                const _index = tabList.value.findIndex((item) => ((item.code + item.detailPageState) === code + state) || (item.code === code && item.detailPageState !== state));
                if (_index > -1 && !_.isEqual(data, tabList.value[_index]?.detailData)) {
                    tabList.value[_index] = dataGather;
                }
                activeTabs.value = code + state;
                if (code === ctx.$route.query.id) return;
                jumpToDetail({ id: code });
            }
        };

        const handleAddRow = (type) => {
            const newItem = {
                edit: 2,
                sealAdminName: undefined,
                accountType: type,
                allowEdit: true,
                accountRegistrant: userCode,
                accountRegistrantName: userName,
                accountManager: userCode,
                accountManagerName: userName,
                accountPasswordVisible: false,
                registrantPhoneVisible: false,
                websiteAccountVisible: false
            };
            newItem.backup = _.cloneDeep(newItem);
            delete newItem.backup.backup;
            const disableProps = [];
            if (accountRegistrantDisabled.value) {
                disableProps.push('accountRegistrant');
            }
            if (accountManagerDisabled.value) {
                disableProps.push('accountManager');
            }
            if (type === '1') {
                disableProps.push('customerName');
                newItem.notNecessaryProps = [...defaultNotNecessaryProps, 'customerName'];
            } else {
                newItem.notNecessaryProps = defaultNotNecessaryProps;
            }
            if (disableProps.length > 0) {
                newItem.disableProps = disableProps;
            }
            accountList.totalData.value.unshift(newItem);
        };

        const handleBtnEvent = (row, event, index) => {
            if (event === 'discard') {
                handleDiscard(row);
            } else if (event === 'enable') {
                handleEnable(row);
            }
            filterEventBus.$emit('close-all-filters');
        };

        const handleDiscard = (row) => {
            MessageBox.confirm('确定要废弃该数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                biddingAccountDiscardApi({ id: row.id }).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('废弃成功');
                        accountList.getList();
                    }
                });
            }).catch(() => { });
        };

        const handleEnable = (row) => {
            row.enableLoading = true;
            biddingAccountEnableApi({ id: row.id }).then(res => {
                row.enableLoading = false;
                if (res && +res.code === 0) {
                    Message.success('重启成功');
                    accountList.getList();
                }
            }).catch(() => {
                row.enableLoading = false;
            });
        };

        const handleElementChange = ({ prop, val, row, index }) => {
            if (prop === 'accountManager') {
                row.accountManagerStatus = undefined;
            }
        };

        const handleSort = ({ prop, order }) => {
            accountList.getList({
                orderBy: prop?.replace(/([A-Z])/g, '_$1').toLowerCase(),
                orderByType: order === 'ascending' ? 'asc' : 'desc'
            });
        };
        const currentFilterObj = ref({});
        const searchDataFormat = (condition = {}, type = 'search') => {
            const numberProps = ['hasUpdateIn90days', 'isReviewed'];
            const dateProps = ['updateTime', 'createTime'];
            let _params;
            if (type === 'colFilter') {
                _params = { ...condition, ..._.cloneDeep(currentFilterObj.value) };
            } else {
                _params = { ..._.cloneDeep(currentFilterObj.value), ...condition };
            }

            Object.keys(_params).forEach(v => {
                !_params[v] && _params[v] !== 0 && (_params[v] = undefined);
            });

            const page = { ..._.pick(_params, ['pageNo', 'pageSize']) };
            const filterCondition = _.omit(_params, ['pageNo', 'pageSize']);

            numberProps.forEach(prop => {
                if (filterCondition[prop] !== undefined && filterCondition[prop] !== null) {
                    filterCondition[prop] = Number(filterCondition[prop]);
                }
            });

            dateProps.forEach(prop => {
                if (filterCondition[prop] && Array.isArray(filterCondition[prop]) && filterCondition[prop].length === 2) {
                    filterCondition[`${prop}From`] = filterCondition[prop][0];
                    filterCondition[`${prop}To`] = filterCondition[prop][1];
                    delete filterCondition[prop];
                }
            });

            let result;
            if (type === 'colFilter') {
                result = { ...condition, ...filterCondition };
            } else {
                result = { ...filterCondition };
            }
            return { ...result, ...page };
        };
        const handleColFilter = ({ prop, value }) => {
            currentFilterObj.value[prop] = value;
            accountList.getList({ ...currentFilterObj.value });
        };

        const maskAccount = (account) => {
            if (!account || account.length <= 4) return account;
            return account.substring(0, 2) + '***' + account.substring(account.length - 2);
        };

        const getWebsiteUrl = (url) => {
            if (!url) return '';
            if (url.startsWith('http://') || url.startsWith('https://')) {
                return url;
            }
            return 'https://' + url;
        };

        const globalVisibleMap = {
            accountPassword: ref(false),
            websiteAccount: ref(false),
            registrantPhone: ref(false)
        };
        const getGlobalVisible = (fieldType) => {
            return globalVisibleMap[fieldType]?.value || false;
        };
        const getFieldVisible = (fieldType) => {
            const fieldMap = globalVisibleMap[fieldType];
            return fieldMap && fieldMap.value;
        };
        const setGlobalVisible = (fieldType, value) => {
            if (globalVisibleMap[fieldType]) {
                globalVisibleMap[fieldType].value = value;
            }
        };

        const toggleGlobalPassword = (fieldType) => {
            const current = getGlobalVisible(fieldType);
            setGlobalVisible(fieldType, !current);
            if (!current) {
                accountList.totalData.value.forEach(row => {
                    row[fieldType + 'Visible'] = true;
                    if (row.backup) {
                        row.backup[fieldType + 'Visible'] = true;
                    }
                });
            }
        };
        const getRowPasswordShow = (row, fieldType) => {
            const key = fieldType + 'Visible';
            return getGlobalVisible(fieldType) && row[key];
        };
        const toggleRowPassword = (row, fieldType) => {
            const key = fieldType + 'Visible';
            const globalVisible = getGlobalVisible(fieldType);
            if (!globalVisible) {
                setGlobalVisible(fieldType, true);
                accountList.totalData.value.forEach(rowItem => {
                    rowItem[key] = (rowItem === row);
                    if (rowItem.backup) {
                        rowItem.backup[key] = (rowItem === row);
                    }
                });
            } else {
                row[key] = !row[key];
                if (row.backup) {
                    row.backup[key] = row[key];
                }
            }
        };

        // const openImport = () => {
        //     setupContext.refs.fileDialogRef.openImport();
        // };

        // const uploadSuccessHandle = () => {
        //     accountList.getList();
        // };

        // const uploadFailHandle = () => {
        //     accountList.getList();
        // };

        const toExcelTitle = (item) => ({
            name: item.name,
            property: item.property
        });

        const handleExport = async () => {
            await setupContext.refs.searchBox.submitSearch();
            const { value } = accountList.searchModel;
            const newData = _.cloneDeep(value);
            const excelFileList = otherUtils.sortColumnsByFixed(config.columns);
            const excelTitleList = excelFileList?.map(toExcelTitle);
            const params = {
                ...searchDataFormat(newData),
                excelTitleList
            };
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            biddingAccountExportApi(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            });
        };

        const handleBatchSave = () => {
            const saveData = accountList.totalData.value.filter(v => v.edit === 2);
            if (saveData.length === 0) {
                Message.warning('暂无需要保存的数据');
                return;
            }
            const isValid = setupContext.refs.editTableBoxRef.tableExamine(saveData);
            if (!isValid) {
                return;
            }
            const hasSpaceData = [];
            saveData.forEach((v) => {
                const originalIndex = accountList.totalData.value.findIndex(item => item === v);
                const passwordHasSpace = v.accountPassword && /\s/.test(v.accountPassword);
                const accountHasSpace = v.websiteAccount && /\s/.test(v.websiteAccount);
                if (passwordHasSpace || accountHasSpace) {
                    hasSpaceData.push({
                        ...v,
                        originalIndex: originalIndex + 1,
                        passwordHasSpace,
                        accountHasSpace
                    });
                }
            });
            const invalidCustomerNameData = saveData.filter(v => {
                return v.accountType === '2' && !v.customerName;
            });
            if (invalidCustomerNameData.length > 0) {
                const invalidRows = invalidCustomerNameData.map(v => {
                    const originalIndex = accountList.totalData.value.findIndex(item => item === v);
                    return `第${originalIndex + 1}行：${v.websiteName || '未命名网站'}`;
                }).join('、');
                Message.warning(`私网类型账号的客户名称为必填项，请检查：${invalidRows}`);
                return;
            }
            const formatData = saveData.map(v => {
                const { edit, allowEdit, enableLoading, ...rest } = v;
                return rest;
            });
            const passwordSpaceMsg = hasSpaceData.filter(v => v.passwordHasSpace);
            const accountSpaceMsg = hasSpaceData.filter(v => v.accountHasSpace);
            const confirmMsgParts = [];
            if (accountSpaceMsg.length > 0) {
                confirmMsgParts.push(`以下网站名称的账号存在空格：<br />${accountSpaceMsg.map(v => `第${v.originalIndex}行：${v.websiteName}`).join('<br />')}<br />`);
            }
            if (passwordSpaceMsg.length > 0) {
                confirmMsgParts.push(`以下网站名称的密码存在空格：<br />${passwordSpaceMsg.map(v => `第${v.originalIndex}行：${v.websiteName}`).join('<br />')}<br />`);
            }
            const confirmMsg = confirmMsgParts.length > 0 ? confirmMsgParts.join('') : '';
            MessageBox.confirm(`${confirmMsg}请确认是否保存选中的 ${saveData.length} 条数据？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                biddingAccountBatchSaveApi(formatData).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('保存成功');
                        accountList.getList();
                    }
                });
            }).catch(() => { });
        };
        const permissionData = ref({
            isSystemAdmin: false,
            isTendererManager: false
        });
        // 总部营管和系统管理员允许修改
        const canEditAccount = computed(() => {
            return permissionData.value.isSystemAdmin || permissionData.value.isTendererManager;
        });
        // 管理员特权可改
        const accountRegistrantDisabled = computed(() => {
            return !permissionData.value.isSystemAdmin;
        });
        const accountManagerDisabled = computed(() => {
            return !canEditAccount.value;
        });
        const dictDatas = ref({});
        const updateColumnDisabled = () => {
            const accountRegistrantCol = config.columns.find(col => col.prop === 'accountRegistrant');
            const accountManagerCol = config.columns.find(col => col.prop === 'accountManager');
            if (accountRegistrantCol) {
                accountRegistrantCol.disabled = accountRegistrantDisabled.value;
            }
            if (accountManagerCol) {
                accountManagerCol.disabled = accountManagerDisabled.value;
            }
        };
        watch(() => [permissionData.value.isSystemAdmin, permissionData.value.isTendererManager], () => {
            updateColumnDisabled();
        }, { immediate: true });
        const detailData = ref({});
        const fetchData = id => {
            return getBiddingAccountDetailApi({ id }).then(res => {
                if (+res.code === 0 && res.data) {
                    detailData.value = { ...(res.data || {}), edit: -3 };
                }
            });
        };
        const downTemplateLoading = ref(false);
        const openImport = () => {
            config.importConfig.beforeRequest = (params) => {
                return params;
            };
            setupContext.refs.fileDialogRef.openImport();
        };
        const uploadSuccessHandle = () => {
            accountList.getList();
        };
        const uploadFailHandle = () => {
            accountList.getList();
        };
        onMounted(async () => {
            dictDatas.value = await otherUtils.getDictDataList(config.columns, ['LCRM_PRIVILEGED_ROLE_LIST']);
            await getBiddingAccountPermissionApi({}).then(res => {
                if (res && +res.code === 0) {
                    /**
                     * systemAdmin  是否是系统管理员
                     * salesManager 是否是销售管理
                     * normalSales  是否是普通营销组员  查看权限
                     * accountManager 是否是总部账号管理人
                     * */
                    // 账号管理人  总部营管和系统管理员允许修改
                    // 账号注册人   管理员特权可改
                    permissionData.value = {
                        isSystemAdmin: res.data?.systemAdmin || false,
                        isTendererManager: res.data?.tendererManager || false
                    };
                    updateColumnDisabled();
                }
            });

            if (ctx.$route.query.accountManager) {
                setupContext.refs.searchBox.setQueryParams({
                    accountManager: ctx.$route.query.accountManager,
                    accountStatus: 'active'
                });
                await setupContext.refs.searchBox.submitSearch();
            } else {
                await setupContext.refs.searchBox.submitSearch();
                if (ctx.$route.query.id) {
                    await fetchData(ctx.$route.query.id);
                    detailData.value.id && rowDBclick(detailData.value);
                }
            }
        });

        return {
            accountList,
            config,
            authorityCode,
            tabList,
            activeTabs,
            dictDatas,
            holePageLoading,
            codesToNames: otherUtils.codesToNames,
            desensitization: otherUtils.desensitization,
            canEditAccount,
            handleAddRow,
            handleBtnEvent,
            handleElementChange,
            handleSort,
            handleColFilter,
            handleExport,
            handleBatchSave,
            otpColumnConfig,
            showColumnConfigDialog,
            removeTab,
            switchTabs,
            rowDBclick,
            maskAccount,
            getWebsiteUrl,
            downTemplateLoading,
            openImport,
            uploadSuccessHandle,
            uploadFailHandle,
            iconCloseEyes,
            iconOpenEyes,
            globalVisibleMap,
            getGlobalVisible,
            getFieldVisible,
            toggleGlobalPassword,
            getRowPasswordShow,
            toggleRowPassword
        };
    }
};
</script>
<style lang="less">
.bidding-account-manage {
    width: 100%;

    .bidding-account-manage-paper {
        height: 100%;
    }

    .bidding-list-tab-pane.el-tabs {
        width: 100%;
        height: 100%;

        &>.el-tabs__content {
            height: calc(100% - 40px - 14px);
            overflow: auto;

            &>.el-tab-pane {
                overflow: auto;
                padding-right: 5px;
                height: 100%;

                .list-main {
                    .edit-table-box {
                        height: 100%;
                    }
                }
            }
        }
    }

    .list-layout-wrapper {
        height: 100%;
    }

    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .list-header {
        .bidding-account-manage-list-dropdown.el-dropdown {
            color: #fff;
        }
    }

    .layout-content.bidding-account-manage-paper {
        padding: 0px 20px 20px;
    }

    .list-layout-wrapper {
        padding: 0px;
    }

    .header-button::after {
        content: "";
        display: table;
        clear: both;
    }

    .header-button button {
        float: left;
    }

    .website-url-link {
        color: #409EFF;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    .slot-box {
        display: flex;
        align-items: center;
    }

    .header-label-text {
        flex-shrink: 0;
    }

    .text-eyes {
        width: 14px;
        margin-left: 4px;
        flex-shrink: 0;
        cursor: pointer;
    }

    .col-header-filter {
        margin-left: 4px;
    }

    .slot-box {
        cursor: pointer;
        flex-shrink: 0;
        &.header-slot-box {
            justify-content: space-between;
            cursor: pointer;
            width: 100%;
        }
    }

    .password-cell {
        display: flex;
        align-items: center;
        gap: 4px;

        .password-text {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .row-eyes {
            width: 14px;
            cursor: pointer;
            flex-shrink: 0;
        }
    }
}

.bidding-account-manage-list-dropdown.el-dropdown {
    color: #fff;
    vertical-align: middle;

    .el-button--mini {
        padding: 7px 15px;
    }
}

.bidding-account-manage-list-dropdown-menu {
    background: #fff;
    padding: 0;
    white-space: nowrap;

    .dropdown-item {
        width: 130px !important;
        color: #333;
        font-size: 14px;
        padding: 8px 20px;
        line-height: 1.5;
        cursor: pointer;
        transition: background 0.2s, color 0.2s;
        text-align: center;
        justify-content: center;
        display: flex;
        color: #4285f5;
    }

    .dropdown-item:hover {
        background: #f5f7fa;
        color: #4285f5;
    }
}
</style>
